import React, { useEffect } from "react";
import { useCookies } from 'react-cookie';
import styled from 'styled-components/macro';


const AnimatedHint = styled.div`
    position: absolute;
    top: 50%;
    left: ${(props) => (props.$left ? '10%' : props.$right ? '90%' : '50%')};
    transform: translate(-50%, -40%);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;

const IconImage = styled.img`
    //width: 25px;
    //height: 25px;
    opacity: 1;
`;


const ToolbarAnimatedHint = ({ select, position }) => {
    const [showHint, setShowHint] = React.useState(false);
    const [iconType, setIconType] = React.useState('start');
    const [cookies] = useCookies(['CookieConsent']);

    useEffect(() => {
        if (cookies.CookieConsent === undefined) return;
        setShowHint(false);
        const startTimer = setTimeout(() => {
            setShowHint(true);
        }, 1500);

        return () => {
            clearTimeout(startTimer);
        };
    }, [cookies.CookieConsent]);

    useEffect(() => {
        let animationCycle;
        if (showHint) {
            let phase = 0;

            animationCycle = setInterval(() => {
                phase++;
                if (phase === 1) {
                    setIconType('start');
                } else if (phase === 2) {
                    setIconType('clicked');
                    if (select) select(true);
                } else if (phase === 4) {
                    setIconType('start');
                    if (select) select(false);
                } else if (phase >= 5) {
                    setShowHint(false);
                    clearInterval(animationCycle);
                    phase = 0;
                    setTimeout(() => {
                        setShowHint(true);
                        phase = 0;
                    }, 5000);
                }
            }, 500);
        }

        return () => {
            clearInterval(animationCycle);
        };
  }, [showHint]);

    return (
        showHint && (
            <AnimatedHint $left={position === 'left'} right={position === 'right'}>
                <IconImage
                    src={iconType === 'start' ? '/assets/hand.png' : '/assets/hand_clicked.png'}
                    width={'25px'}
                    height={'25px'}
                />
            </AnimatedHint>
        )
    );
}

export default ToolbarAnimatedHint;
